import classnames from 'classnames/bind'

import format from 'date-fns/format'

// Styles
import styles from './style.module.scss'

interface CouponOptionProps {
  handleClick?: () => void
  item: { couponCode: string; usageConditionDesc: string[]; couponName: string; promotionEndAt: string }
}

const cx = classnames.bind(styles)
const CouponOption = ({ item, handleClick }: CouponOptionProps) => {
  const date = format(new Date(item?.promotionEndAt), 'yyyy/MM/dd')
  return (
    <div className={cx('deliver-option')} onClick={handleClick}>
      <div className={cx('deliver-option-wrapper')}>
        <div className={cx('deliver-option-content')}>
          <div className={cx('deliver-option-content-title')}>{item.couponName}</div>
          <ul className={cx('deliver-option-content-description')}>
            {item.usageConditionDesc.map((description: string, index: number) => (
              <li key={index} className={cx('deliver-option-content-description-text')}>
                {description}
              </li>
            ))}
            <li className={cx('deliver-option-content-description-text')}>{`使用期限：${date}`}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CouponOption
